import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-commit",
  "use": "icon-commit-usage",
  "viewBox": "0 0 12 6",
  "content": "<symbol viewBox=\"0 0 12 6\" id=\"icon-commit\"><g fill=\"currentColor\"><path d=\"M6 5a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6z\" /><path d=\"M.876 3.562c-.207 0-.376-.224-.376-.5s.169-.5.376-.5H3.5v1H.876zm7.514 0v-1h2.632c.203 0 .368.224.368.5s-.165.5-.368.5H8.39z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol